"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListingImageV = _interopRequireDefault(require("../elements-image/ListingImageV2"));
var _lodash = require("lodash");
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Concierge = function Concierge(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var item = items[0];
  if (!item) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Banner img-rounded"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _lodash.get)(item, 'contentLinkUrl')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-header"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-gray-800"
  }, (0, _lodash.get)(item, 'contentTitle')), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default",
    type: "button",
    name: "button"
  }, (0, _lodash.get)(item, 'contentSubtitle1'))), /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    offset: 100,
    placeholder: _placeholderImg.default,
    once: true
  }, /*#__PURE__*/_react.default.createElement(_ListingImageV.default, {
    sizes: '100vw',
    imgId: (0, _lodash.get)(items, '[0].contentCloudinaryId'),
    alt: (0, _lodash.get)(items, '[0].imageAltText'),
    ratio: 2140 / 480,
    widths: ['2000', '4000'],
    className: "img-cover banner-image"
  })))));
};
Concierge.propTypes = {
  items: _propTypes.default.array
};
var _default = exports.default = Concierge;